import DescribeVideo from "../../Assets/Videos/DescribeThem2.mp4";
import HashtagVideo from "../../Assets/Videos/UseHashtag.mp4";
import SaveEventVideo from "../../Assets/Videos/SaveEvent.mp4";
import SuggestedProductsVideo from "../../Assets/Videos/SuggestedProducts.mp4";

/**
 * Homepage category pills data
 * Uses translation keys for name and description
 */
export const categories = [
    {
        nameKey: "stylish",
        descriptionKey: "personalityTypes.descriptions.stylish",
        bgColor: "bg-yellow-900/40",
        bgColor2: "bg-red-900",
    },
    {
        nameKey: "foodie",
        descriptionKey: "personalityTypes.descriptions.foodie",
        bgColor: "bg-red-900/40",
        bgColor2: "bg-red-700",
    },
    {
        nameKey: "romantic",
        descriptionKey: "personalityTypes.descriptions.romantic",
        bgColor: "bg-red-700/40",
        bgColor2: "bg-red-500",
    },
    {
        nameKey: "creative",
        descriptionKey: "personalityTypes.descriptions.creative",
        bgColor: "bg-teal-800/40",
        bgColor2: "bg-green-900",
    },
    {
        nameKey: "elegant",
        descriptionKey: "personalityTypes.descriptions.elegant",
        bgColor: "bg-teal-600/40",
        bgColor2: "bg-green-700",
    },
    {
        nameKey: "artistic",
        descriptionKey: "personalityTypes.descriptions.artistic",
        bgColor: "bg-emerald-300/40",
        bgColor2: "bg-green-500",
    },
    {
        nameKey: "techSavvy",
        descriptionKey: "personalityTypes.descriptions.techSavvy",
        bgColor: "bg-orange-400/40",
        bgColor2: "bg-orange-500",
    },
    {
        nameKey: "unique",
        descriptionKey: "personalityTypes.descriptions.unique",
        bgColor: "bg-orange-300/40",
        bgColor2: "bg-orange-300",
    },
    {
        nameKey: "oldSoul",
        descriptionKey: "personalityTypes.descriptions.oldSoul",
        bgColor: "bg-red-300/40",
        bgColor2: "bg-red-100",
    },
];

/**
 * Homepage rotating words for the dynamic title
 */
export const words = [
    "words.mother",
    "words.father",
    "words.friend",
    "words.partner",
    "words.children",
    "words.teacher",
    "words.neighbor",
];

/**
 * Homepage video sections data
 * Uses translation keys for titles, descriptions, and button text
 */
export const sections = [
    {
        id: "describe",
        titleKey: "homepage.sections.describe.title",
        descriptionKey: "homepage.sections.describe.description",
        videoUrl: DescribeVideo,
        duration: 8,
        type: "video",
        buttonTextKey: "homepage.sections.describe.buttonText",
        buttonLink: "/search",
    },
    {
        id: "hashtag",
        titleKey: "homepage.sections.hashtag.title",
        descriptionKey: "homepage.sections.hashtag.description",
        videoUrl: HashtagVideo,
        duration: 10,
        type: "video",
        buttonTextKey: "homepage.sections.hashtag.buttonText",
        buttonLink: "/search",
    },
    {
        id: "events",
        titleKey: "homepage.sections.events.title",
        descriptionKey: "homepage.sections.events.description",
        videoUrl: SaveEventVideo,
        duration: 10,
        type: "video",
        buttonTextKey: "homepage.sections.events.buttonText",
        buttonLink: "/profile",
    },
    {
        id: "scale",
        titleKey: "homepage.sections.scale.title",
        descriptionKey: "homepage.sections.scale.description",
        videoUrl: SuggestedProductsVideo,
        duration: 9,
        type: "video",
        buttonTextKey: "homepage.sections.scale.buttonText",
        buttonLink: "/search",
    },
];
